import Config from '@netx/core-app/config';

Object.assign(Config, {
	CSS_CUSTOM_PROPERTY_PREFIX: '--mdc-theme-',
	PASSIVE_ALERT_DELAY: 2500,
	CONTACT_EMAIL: ['support@netx.net'],
});

export default Config;
